import * as React from 'react'
import { twMerge } from 'tailwind-merge'

function Input({ className, children, ...props }: React.ComponentProps<'div'>) {
  return (
    <div data-slot="input" className={twMerge('flex flex-col gap-2', className)} {...props}>
      {children}
    </div>
  )
}

function InputLabel({ className, children, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="input-label"
      className={twMerge('text-foreground-secondary text-sm font-medium', className)}
      {...props}
    >
      {children}
    </div>
  )
}

function InputField({ className, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      data-slot="input-field"
      className={twMerge(
        'text-md flex w-full min-w-0 px-4 py-3 font-medium', // Layout
        'rounded-lg border bg-transparent outline-none transition-[color,box-shadow]', // Container
        'placeholder:text-foreground-disabled text-foreground-secondary', // Text
        'border-border hover:border-hover focus-visible:border-[color:var(--focus-ring-color)]', // Border and focus state
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50', // Disabled state
        'aria-invalid:ring-danger/20 dark:aria-invalid:ring-danger/40 aria-invalid:border-danger', // Data validation
        className,
      )}
      {...props}
    />
  )
}

Input.Label = InputLabel
Input.Field = InputField

export { Input }
